import React from 'react';
import { ForumTopic } from '@/api/opoint.schemas';
import ProjectCard from './ProjectCard';

interface ProjectListProps {
  topics: ForumTopic[];
}

const ProjectList: React.FC<ProjectListProps> = ({
  topics,
}: ProjectListProps) => {
  const sortedTopics = [...topics].sort((a, b) => {
    if (!a.closed && b.closed) return -1;
    if (a.closed && !b.closed) return 1;
    return b.posts_count! - a.posts_count!;
  });

  return (
    <div className='grid grid-cols-[repeat(auto-fit,minmax(400px,1fr))] gap-8 justify-items-center'>
      {sortedTopics.map((topic) => (
        <ProjectCard key={topic.id} topic={topic} />
      ))}
    </div>
  );
};

export default ProjectList;
